import CoursesListView from './CoursesListView';

/** Eigene Seite: nur inaktive Kurse. */
export default function CoursesInactiveList() {
  return <CoursesListView mode="inactive" />;
}
